// (function () {
//     'use strict';

//     const module = angular.module('imApp');

//     module.component('campaignProducts', {
//         templateUrl: 'views/components/views/campaignProducts/campaignProducts.template.html?v=' + module.version,
//         controllerAs: 'vm',
//         controller: ['$stateParams', 'stateService', 'ttGridFactory', function ($stateParams, stateService, ttGridFactory) {

//             // #region VARIABLES & DEFINITIONS

//             const vm = this;
//             let campaignKeyno = $stateParams.campaign_keyno;

//             vm.model = {
//                 gridReady: false
//             };

//             // TODO: Are there a better way to bail if not valid input argument for this page?
//             if (campaignKeyno === '') {
//                 return stateService.go('campaigns');
//             }

// 		    vm.grid = new ttGridFactory({
// 			    rememberId: 'campaignproducts.grid.list',
// 			    kendo: {
// 				    height: '100%',
// 				    sortable: true,
// 				    aggregate: true,
// 				    pager: false,
// 				    selectable: false,
// 				    filterable: false
// 			    }
// 		    });
		    
//             // #endregion VARIABLES & DEFINITIONS

// 		    // #region GRID PROCEDURE FUNCTION CALLS
		    
// 		    async function loadGrid() {
// 			    vm.grid.dataTask.loadData = {
// 				    method: 2225,
// 				    parameters: { campaign_keyno: campaignKeyno }
// 			    };
			    
//     			vm.model.gridReady = true;
			    
//     			if (vm.grid.gridfunc !== null) vm.grid.gridfunc.read();
// 		    }
		    
// 		    // #endregion GRID PROCEDURE FUNCTION CALLS
		    
// 		    // #region ON INIT FUNCTION
		    
// 		    vm.$onInit = async function () {
// 			    loadGrid();
// 		    }
		    
// 		    // #endregion ON INIT FUNCTION
		    
//         }]
//     });
// })();
